import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface DbMenuItem {
  id: string;
  label: string;
  url: string;
  parent_id: string | null;
  sort_order: number;
  is_visible: boolean;
  is_highlight: boolean;
  icon: string | null;
  description: string | null;
}

export function useMenuItems() {
  return useQuery({
    queryKey: ["menu-items-public"],
    queryFn: async (): Promise<DbMenuItem[]> => {
      const { data, error } = await supabase
        .from("menu_items")
        .select("id, label, url, parent_id, sort_order, is_visible, is_highlight, icon, description")
        .eq("is_visible", true)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return (data as DbMenuItem[]) ?? [];
    },
    staleTime: 2 * 60 * 1000,
  });
}
